import { ClientInvoiceSettings } from "../types/invoices";

/**
 * What a new invoice for the client starts from: the client's own value where
 * it has one, the workspace's otherwise. Mirrors `resolve_invoice_defaults` on
 * the server, which applies the same rule when a field is left out.
 */
export const resolveInvoiceDefaults = (settings: ClientInvoiceSettings) => {
  const workspace = settings.workspace_defaults;

  return {
    vatRate: settings.vat_rate || workspace?.vat_rate || "",
    paymentMethod: settings.payment_method || workspace?.payment_method || "",
    // Zero is a real term (due on the issue date), not "unset".
    paymentTermDays: settings.payment_term_days ?? workspace?.payment_term_days ?? null,
    numerationSchemaId:
      settings.numeration_schema_id ?? workspace?.numeration_schema_id ?? null,
    receiver:
      settings.receiver_id !== null
        ? { id: settings.receiver_id, name: settings.receiver_name ?? "" }
        : null,
    receiverRole: settings.receiver_role,
  };
};
